import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "./contactForm.css";

export const ContactUs = () => {
  const form = useRef();
  const [formPage, setFormPage] = useState(1);
  const [errors, setErrors] = useState({});

  const validateForm = (page) => {
    const currentErrors = {};
    const formElements = form.current.elements;

    if (page === 1) {
      if (!formElements.firstName.value.trim()) {
        currentErrors.firstName = "First Name is required.";
      }
      if (!formElements.lastName.value.trim()) {
        currentErrors.lastName = "Last Name is required.";
      }
      if (
        !formElements.email.value.trim() ||
        !/\S+@\S+\.\S+/.test(formElements.email.value)
      ) {
        currentErrors.email = "Valid Email is required.";
      }
      if (!formElements.phoneNumber.value.trim()) {
        currentErrors.phoneNumber = "Phone Number is required.";
      }
      if (!formElements.bestTimeToCall.value) {
        currentErrors.bestTimeToCall = "Best Time to Call is required.";
      }
      if (!formElements.officePreference.value) {
        currentErrors.officePreference = "Office Preference is required.";
      }
    } else if (page === 2) {
      if (!formElements.message.value.trim()) {
        currentErrors.message = "Message is required.";
      }

      // ✅ Require consent checkbox
      if (!formElements.contactConsent.checked) {
        currentErrors.contactConsent = "Please agree to be contacted.";
      }
    }

    setErrors(currentErrors);
    return Object.keys(currentErrors).length === 0;
  };

  const sendEmail = (e) => {
    e.preventDefault();
    if (validateForm(2)) {
      emailjs
        .sendForm("service_v8mri3i", "template_e1cg6zo", form.current, {
          publicKey: "IBiv3OL_rmeI7jaUz",
        })
        .then(
          () => {
            alert("Email sent successfully!");
            resetForm();
          },
          (error) => {
            console.log("FAILED...", error.text);
          }
        );
    }
  };

  const resetForm = () => {
    form.current.reset();
    setFormPage(1);
    setErrors({});
  };

  const goToNextPage = () => {
    if (validateForm(1)) {
      setFormPage(2);
    }
  };

  const goToPreviousPage = () => {
    setFormPage(1);
  };

  return (
    <form
      ref={form}
      encType="multipart/form-data"
      method="post"
      onSubmit={sendEmail}
    >
      <div className={`formPage1 ${formPage === 1 ? "active" : ""}`}>
        <div className="form-group">
          <label>
            First Name{" "}
            {errors.firstName && (
              <span className="error">{errors.firstName}</span>
            )}
          </label>
          <input type="text" name="firstName" />
        </div>

        <div className="form-group">
          <label>
            Last Name{" "}
            {errors.lastName && (
              <span className="error">{errors.lastName}</span>
            )}
          </label>
          <input type="text" name="lastName" />
        </div>

        <div className="form-group">
          <label>
            Email{" "}
            {errors.email && <span className="error">{errors.email}</span>}
          </label>
          <input type="email" name="email" />
        </div>

        <div className="form-group">
          <label>
            Phone Number{" "}
            {errors.phoneNumber && (
              <span className="error">{errors.phoneNumber}</span>
            )}
          </label>
          {/* (Optional) consider type="tel" for phone inputs */}
          <input type="number" name="phoneNumber" />
        </div>

        <div className="form-group">
          <label>
            Best Time to Call{" "}
            {errors.bestTimeToCall && (
              <span className="error">{errors.bestTimeToCall}</span>
            )}
          </label>
          <select name="bestTimeToCall">
            <option value="">Select</option>
            <option value="Morning">Morning</option>
            <option value="Afternoon">Afternoon</option>
            <option value="Evening">Evening</option>
          </select>
        </div>

        <div className="form-group">
          <label>
            Office Preference{" "}
            {errors.officePreference && (
              <span className="error">{errors.officePreference}</span>
            )}
          </label>
          <select name="officePreference">
            <option value="">Select</option>
            <option value="Tampa">Fort Lauderdale</option>
            <option value="East Tampa">East Tampa</option>
            <option value="StPete">Saint Petersburg</option>
          </select>
        </div>

        <button className="formButtons" type="button" onClick={goToNextPage}>
          Next
        </button>
      </div>

      <div className={`formPage2 ${formPage === 2 ? "active" : ""}`}>
        <div className="form-group">
          <label>
            About you{" "}
            {errors.message && <span className="error">{errors.message}</span>}
          </label>
          <textarea name="message" />
        </div>

        {/* ✅ Consent checkbox */}
        <div className="form-group checkbox">
          <label className="checkbox-label">
            <input type="checkbox" name="contactConsent" value="yes" />
            <span>
              I agree that Reszko Nation (and its partners) may contact me by
              phone, SMS/MMS, and email regarding my inquiry. Message and data
              rates may apply. Consent is not a condition of purchase. I have
              read and agree to the{" "}
              <a href="/terms" target="_blank" rel="noopener noreferrer">
                Terms
              </a>{" "}
              and{" "}
              <a href="/privacy" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>
              .
            </span>
          </label>
          {errors.contactConsent && (
            <span className="error">{errors.contactConsent}</span>
          )}
        </div>

        <button
          className="formButtons"
          type="button"
          onClick={goToPreviousPage}
        >
          Back
        </button>
        <input className="formButtons" type="submit" value="Submit" />
      </div>
    </form>
  );
};

export default ContactUs;
